var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-more-data",on:{"click":_vm.getMoreData}},[_vm._v(" "+_vm._s(_vm.isReachBottom?"已全部加载":"点我加载更多···")+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }